export default {
  container: {
    mt: '1rem',
  },
  calendarContainer: {
    width: '100%',
    flexDirection: 'column',
    ml: ['1rem', null, null, null, '2rem'],
    px: [0, null, null, null, 6],
  },
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  },
  dayHeader: {
    bg: 'accent',
  },
  legendContainer: {
    alignItems: 'center',
    mt: '1rem',
    transition: '0.4s',
    cursor: 'pointer',
    '&:hover': {
      color: 'text_secondary',
    },
  },
  legendText: {},
  legendButton: {
    width: null,
    height: null,
    p: 0,
    m: 0,
  },
};
